import React from 'react';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, useMediaQuery, useTheme } from '@mui/material';
import { Close } from '@mui/icons-material';

interface PolicyModalProps {
  open: boolean;
  title: string;
  content: string;
  onClose: () => void;
}

export const PolicyModal = ({ open, title, content, onClose }: PolicyModalProps) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth fullScreen={isSmallScreen}>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {title}
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{ lineHeight: 1.7, '& p': { margin: '0', '&:last-child': { marginBottom: 0 } } }}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </DialogContent>
    </Dialog>
  );
};
